//import x from "y"
import Swiper from "swiper/swiper-bundle.mjs";
import "swiper/swiper-bundle.css";
import { initBurgerMenu } from "./burger-menu.js";
import {
  initSwiperInteractiveElements,
  SWIPER_NO_SWIPE_SELECTOR,
} from "./swiper-interactive-links.js";
import { initSwiperNestedScroll } from "./swiper-nested-scroll.js";

document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM Content Loaded");

  // Fullscreen Scrolling mit Swiper - Fullpage.js Style
  const fullscreenSwiper = document.querySelector(".fullscreen-swiper");
  if (fullscreenSwiper) {
    // Initial Slide basierend auf URL (mit oder ohne Hash) oder Slug berechnen
    let initialSlide = 0;
    const path = window.location.pathname;
    const hash = window.location.hash;

    // Versuche zuerst über URL-Pfad (ohne Hash) - z.B. /seite-slug
    if (path && path !== "/") {
      const pathParts = path.split("/").filter((p) => p);
      if (pathParts.length > 0) {
        const pathSlug = pathParts[pathParts.length - 1]; // Letzter Teil des Pfads
        const slides = fullscreenSwiper.querySelectorAll(".swiper-slide");
        slides.forEach((slide, index) => {
          const slideSlug = slide.getAttribute("data-slug");
          if (slideSlug === pathSlug) {
            initialSlide = index;
          }
        });
      }
    } else if (hash) {
      // Fallback: Versuche über Hash
      const slideIdMatch = hash.match(/#slide-(\d+)/);
      if (slideIdMatch) {
        const targetSlideId = slideIdMatch[1];
        const slides = fullscreenSwiper.querySelectorAll(".swiper-slide");
        slides.forEach((slide, index) => {
          if (slide.getAttribute("data-slide-id") === targetSlideId) {
            initialSlide = index;
          }
        });
      } else {
        const slideIndexMatch = hash.match(/#slide(\d+)/);
        if (slideIndexMatch) {
          const slideIndex = parseInt(slideIndexMatch[1]) - 1;
          if (slideIndex >= 0) {
            initialSlide = slideIndex;
          }
        } else {
          const slug = hash.replace("#", "");
          const slides = fullscreenSwiper.querySelectorAll(".swiper-slide");
          slides.forEach((slide, index) => {
            if (slide.getAttribute("data-slug") === slug || slide.id === slug) {
              initialSlide = index;
            }
          });
        }
      }
    }

    const getActiveSlideContent = () =>
      fullscreenSwiper
        .querySelector(".swiper-slide-active")
        ?.querySelector(".slide-content") ?? null;

    initSwiperNestedScroll(fullscreenSwiper, getActiveSlideContent);
    initSwiperInteractiveElements(fullscreenSwiper);

    const swiper = new Swiper(".fullscreen-swiper", {
      direction: "vertical",
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 700, // Schnelleres Scrollen für besseres Gefühl
      initialSlide: initialSlide,
      // Snapping aktivieren - wichtig für Fullpage-Verhalten
      freeMode: false,
      resistance: true,
      resistanceRatio: 0,
      // Mausrad/Trackpad - wird durch Custom Handler gesteuert
      mousewheel: {
        enabled: false, // Deaktiviert, wird durch Custom Handler gesteuert
      },
      // Tastatur-Navigation
      keyboard: {
        enabled: true,
        onlyInViewport: false,
        pageUpDown: true,
      },
      touchEventsTarget: "container",
      allowTouchMove: true,
      // Maus-Klicks simulieren kein Touch → Klick löst keinen Slide-Wechsel aus
      simulateTouch: false,
      // Textauswahl in Content-Bereichen erlauben
      touchStartPreventDefault: false,
      touchStartForcePreventDefault: false,
      noSwiping: true,
      noSwipingSelector: SWIPER_NO_SWIPE_SELECTOR,
      touchRatio: 1,
      threshold: 5,
      longSwipesRatio: 0.5,
      longSwipesMs: 300,
      // Pagination
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        type: "bullets",
        dynamicBullets: false,
      },
      // Navigation Buttons
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      // Snap-Effekt wie bei fullpage.js
      effect: "slide",
      // Wichtig: Slides müssen genau 100vh sein für Snapping
      autoHeight: false,
      // Hash Navigation deaktiviert - verwenden unsere eigene Logik
      hashNavigation: false,
      // Loop deaktiviert für echtes Fullpage-Verhalten
      loop: false,
      // Slide-Änderung Events
      on: {
        slideChange: function () {
          // URL Hash wird im swiper.on("slideChange") Handler aktualisiert
          // Hier nicht aktualisieren, um Konflikte zu vermeiden
        },
      },
    });

    // Custom Mousewheel Handler: Erst innerhalb des Slides scrollen, erst am Rand zum nächsten Slide
    const swiperContainer = fullscreenSwiper;
    let wheelTimeout;
    let accumulatedDelta = 0;
    const threshold = 500; // Mindest-Scroll-Delta für Slide-Wechsel (deutlich erhöht für weniger Sensitivität)
    let lastWheelTime = 0;
    const minWheelInterval = 300; // Mindestzeit zwischen Wheel-Events für Slide-Wechsel (ms)
    let isTransitioning = false; // Flag für laufende Transition

    let currentPageTitleForSlide = "";

    const updatePageTitleFromSlides = () => {
      const idx = swiper.activeIndex;
      const activeSlide = swiper.slides[idx];
      if (!activeSlide) return;
      let pageTitle = activeSlide.getAttribute("data-slide-title");
      const slug = activeSlide.getAttribute("data-slug");
      if (!pageTitle || pageTitle.trim() === "") {
        pageTitle = slug
          ? slug.replace(/[-_]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
          : null;
      }
      const siteName = document.body.getAttribute("data-site-name") || "";
      const newTitle = pageTitle
        ? siteName
          ? `${pageTitle} | ${siteName}`
          : pageTitle
        : null;
      if (newTitle) {
        currentPageTitleForSlide = newTitle;
        document.title = newTitle;
      }
    };

    // Seitentitel bei Slide-Wechsel beibehalten
    const titleEl = document.querySelector("title");
    if (titleEl) {
      let isUpdatingTitle = false;
      const titleObserver = new MutationObserver(() => {
        // Verhindere Endlosschleife: Wenn wir gerade den Titel setzen, ignoriere die Änderung
        if (isUpdatingTitle) return;

        if (
          currentPageTitleForSlide &&
          document.title !== currentPageTitleForSlide
        ) {
          isUpdatingTitle = true;
          document.title = currentPageTitleForSlide;
          setTimeout(() => {
            isUpdatingTitle = false;
          }, 100);
        }
      });
      titleObserver.observe(titleEl, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    swiperContainer.addEventListener(
      "wheel",
      (e) => {
        // Während Transition kein Scrollen erlauben
        if (isTransitioning) {
          e.preventDefault();
          return;
        }

        e.stopPropagation(); // Verhindere Swiper's Standard-Verhalten

        const activeSlide = swiper.slides[swiper.activeIndex];
        const slideContent = activeSlide?.querySelector(".slide-content");

        const now = Date.now();
        const timeSinceLastWheel = now - lastWheelTime;

        if (!slideContent) {
          // Kein Content -> direkt Slide-Wechsel
          accumulatedDelta += Math.abs(e.deltaY);
          if (
            accumulatedDelta >= threshold &&
            timeSinceLastWheel >= minWheelInterval
          ) {
            if (e.deltaY > 0 && swiper.activeIndex < swiper.slides.length - 1) {
              swiper.slideNext();
              lastWheelTime = now;
              setTimeout(updatePageTitleFromSlides, 800);
            } else if (e.deltaY < 0 && swiper.activeIndex > 0) {
              swiper.slidePrev();
              lastWheelTime = now;
              setTimeout(updatePageTitleFromSlides, 800);
            }
            accumulatedDelta = 0;
          }
          return;
        }

        const isScrollable =
          slideContent.scrollHeight > slideContent.clientHeight;
        if (!isScrollable) {
          // Nicht scrollbar -> direkt Slide-Wechsel
          accumulatedDelta += Math.abs(e.deltaY);
          if (
            accumulatedDelta >= threshold &&
            timeSinceLastWheel >= minWheelInterval
          ) {
            if (e.deltaY > 0 && swiper.activeIndex < swiper.slides.length - 1) {
              swiper.slideNext();
              lastWheelTime = now;
              setTimeout(updatePageTitleFromSlides, 800);
            } else if (e.deltaY < 0 && swiper.activeIndex > 0) {
              swiper.slidePrev();
              lastWheelTime = now;
              setTimeout(updatePageTitleFromSlides, 800);
            }
            accumulatedDelta = 0;
          }
          return;
        }

        // Content ist scrollbar
        const scrollTop = slideContent.scrollTop;
        const scrollHeight = slideContent.scrollHeight;
        const clientHeight = slideContent.clientHeight;
        const tolerance = 5; // Etwas größere Toleranz
        const isAtTop = scrollTop <= tolerance;
        const isAtBottom = scrollTop + clientHeight >= scrollHeight - tolerance;

        if (e.deltaY > 0) {
          // Nach unten scrollen
          if (isAtBottom) {
            // Ganz unten -> zum nächsten Slide
            accumulatedDelta += Math.abs(e.deltaY);
            if (
              accumulatedDelta >= threshold &&
              Date.now() - lastWheelTime >= minWheelInterval &&
              swiper.activeIndex < swiper.slides.length - 1
            ) {
              swiper.slideNext();
              lastWheelTime = Date.now();
              accumulatedDelta = 0;
              setTimeout(updatePageTitleFromSlides, 800);
            }
          } else {
            // Nicht ganz unten -> normales Scrollen innerhalb des Contents
            accumulatedDelta = 0;
            // Erlaube normales Scrollen (passiert automatisch)
          }
        } else if (e.deltaY < 0) {
          // Nach oben scrollen
          if (isAtTop) {
            // Ganz oben -> zum vorherigen Slide
            accumulatedDelta += Math.abs(e.deltaY);
            if (
              accumulatedDelta >= threshold &&
              Date.now() - lastWheelTime >= minWheelInterval &&
              swiper.activeIndex > 0
            ) {
              swiper.slidePrev();
              lastWheelTime = Date.now();
              accumulatedDelta = 0;
              setTimeout(updatePageTitleFromSlides, 800);
            }
          } else {
            // Nicht ganz oben -> normales Scrollen innerhalb des Contents
            accumulatedDelta = 0;
            // Erlaube normales Scrollen (passiert automatisch)
          }
        }

        // Reset accumulatedDelta nach längerer Zeit
        clearTimeout(wheelTimeout);
        wheelTimeout = setTimeout(() => {
          accumulatedDelta = 0;
        }, 1000); // Längere Zeit für weniger Sensitivität
      },
      { passive: false },
    );

    // Beim Slide-Wechsel: Content zum Anfang scrollen und Menü aktualisieren
    const updateActiveMenuItem = () => {
      const activeIndex = swiper.activeIndex;
      const activeSlide = swiper.slides[activeIndex];
      if (!activeSlide) return;

      const activeSlideId = activeSlide.getAttribute("data-slide-id");
      const activeSlideSlug = activeSlide.getAttribute("data-slug");
      const navLinks = document.querySelectorAll("#main-nav a");

      navLinks.forEach((link) => {
        // Versuche über verschiedene Attribute zu matchen
        const linkSlideIndex = link.getAttribute("data-slide-index");
        const linkPageId = link.getAttribute("data-page-id");
        const linkSlug = link.getAttribute("data-slug");

        // Prüfe ob Link zum aktiven Slide gehört
        let isActive = false;

        // 1. Über data-slide-index (falls vorhanden)
        if (linkSlideIndex !== null) {
          isActive = parseInt(linkSlideIndex) === activeIndex;
        }

        // 2. Über Page-ID
        if (!isActive && linkPageId !== null && activeSlideId !== null) {
          isActive = linkPageId === activeSlideId;
        }

        // 3. Über Slug (wichtig für WordPress-Menü)
        if (!isActive && linkSlug !== null && activeSlideSlug !== null) {
          isActive = linkSlug === activeSlideSlug;
        }

        // 4. Über URL-Href (Fallback)
        if (!isActive) {
          const linkHref = link.getAttribute("href");
          if (linkHref && activeSlideSlug) {
            // Prüfe ob der Link-Href den aktiven Slug enthält
            const linkPath = new URL(linkHref, window.location.origin).pathname;
            const activePath = `/${activeSlideSlug}`;
            isActive = linkPath === activePath || linkPath === activePath + "/";
          }
        }

        if (isActive) {
          link.classList.add("active");
          link.setAttribute("aria-current", "page");
        } else {
          link.classList.remove("active");
          link.removeAttribute("aria-current");
        }
      });

      const mainNav = document.getElementById("main-nav");
      if (mainNav) {
        const onLightSlide = !!activeSlide.querySelector(
          ".zitat-slide, .rechtsgebiete-slide",
        );
        mainNav.classList.toggle("nav-on-light-slide", onLightSlide);
      }
    };

    // Transition startet
    swiper.on("slideChangeTransitionStart", () => {
      isTransitioning = true;
    });

    swiper.on("slideChange", (s) => {
      const instance = s && typeof s.activeIndex !== "undefined" ? s : swiper;
      const activeSlide = instance.slides[instance.activeIndex];
      const slideContent = activeSlide?.querySelector(".slide-content");
      if (slideContent) {
        slideContent.scrollTop = 0;
      }
      accumulatedDelta = 0;

      // Menü sofort aktualisieren
      updateActiveMenuItem();

      // URL und Seitentitel erst NACH der Transition (speed: 700ms), damit activeIndex der neue ist
      setTimeout(() => {
        const slide = swiper.slides[swiper.activeIndex];
        if (!slide) return;
        const slideId = slide.getAttribute("data-slide-id");
        const slug = slide.getAttribute("data-slug");
        const pageTitle = slide.getAttribute("data-slide-title");
        const siteName = document.body.getAttribute("data-site-name") || "";
        const newTitle = pageTitle
          ? siteName
            ? `${pageTitle} | ${siteName}`
            : pageTitle
          : "";

        if (newTitle) {
          currentPageTitleForSlide = newTitle;
          document.title = newTitle;
        }

        const baseUrl = window.location.origin;
        const newUrl = slug
          ? `${baseUrl}/${slug}`
          : `${baseUrl}/#slide-${slideId}`;
        const currentUrl = window.location.href;

        if (currentUrl !== newUrl && !currentUrl.endsWith(`/${slug}`)) {
          window.history.pushState(
            { slideIndex: swiper.activeIndex, slug: slug },
            newTitle,
            `/${slug}`,
          );
          updateCanonicalURL(`/${slug}`);

          if (window.location.hash) {
            window.history.replaceState(
              null,
              newTitle,
              window.location.pathname,
            );
          }
        }
      }, 750);
    });

    // Verhindere, dass andere Event-Handler die URL zurücksetzen
    swiper.on("slideChangeTransitionEnd", () => {
      isTransitioning = false;

      const activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide) return;

      const slug = activeSlide.getAttribute("data-slug");
      const pageTitle = activeSlide.getAttribute("data-slide-title");
      const siteName = document.body.getAttribute("data-site-name") || "";
      const newTitle = pageTitle
        ? siteName
          ? `${pageTitle} | ${siteName}`
          : pageTitle
        : "";

      if (newTitle) {
        currentPageTitleForSlide = newTitle;
        document.title = newTitle;
      }

      const baseUrl = window.location.origin;
      const expectedUrl = `${baseUrl}/${slug}`;
      if (
        window.location.href !== expectedUrl &&
        !window.location.href.endsWith(`/${slug}`)
      ) {
        window.history.replaceState(
          { slideIndex: swiper.activeIndex, slug: slug },
          newTitle,
          `/${slug}`,
        );
      }
    });

    // Menü-Klicks: Scroll zu entsprechendem Slide
    const setupMenuLinks = () => {
      const navLinks = document.querySelectorAll("#main-nav a");
      const slides = swiper.slides;

      navLinks.forEach((link) => {
        // Versuche Slide-Index aus data-Attribut zu bekommen
        let slideIndex = link.getAttribute("data-slide-index");

        if (slideIndex === null) {
          // Wenn kein data-slide-index, versuche über Page-ID zu finden
          const pageId = link.getAttribute("data-page-id");
          if (pageId) {
            slides.forEach((slide, index) => {
              const slideId = slide.getAttribute("data-slide-id");
              if (slideId === pageId) {
                slideIndex = index.toString();
                link.setAttribute("data-slide-index", index);
              }
            });
          }
        }

        // Wenn immer noch nicht gefunden, verwende Index basierend auf Position
        if (slideIndex === null) {
          const linkIndex = Array.from(navLinks).indexOf(link);
          slideIndex = linkIndex.toString();
          link.setAttribute("data-slide-index", linkIndex);
        }

        link.addEventListener("click", (e) => {
          e.preventDefault();
          const index = parseInt(slideIndex);

          if (index >= 0 && index < slides.length) {
            swiper.slideTo(index);
          }
        });
      });
    };

    setupMenuLinks();

    // Initial: Aktives Menü-Item setzen
    // Warte bis DOM und Swiper vollständig geladen sind
    const initActiveMenuItem = () => {
      // Mehrfach versuchen, falls Slides noch nicht geladen sind
      if (swiper.slides.length > 0) {
        updateActiveMenuItem();
      } else {
        setTimeout(() => {
          if (swiper.slides.length > 0) {
            updateActiveMenuItem();
          }
        }, 100);
      }
    };

    // Sofort versuchen
    initActiveMenuItem();

    // Titel sofort setzen (für direkten Aufruf z. B. /kanzlei)
    updatePageTitleFromSlides();

    // Auch nach Swiper init Event
    swiper.on("init", () => {
      updateActiveMenuItem();
      updatePageTitleFromSlides();
    });

    // Nach slideChangeTransitionEnd sicherstellen
    swiper.on("slideChangeTransitionEnd", () => {
      updateActiveMenuItem();
      updatePageTitleFromSlides();
    });

    initBurgerMenu();

    // PopState Event für Browser-Navigation (zurück/vor) - funktioniert mit URLs ohne Hash
    window.addEventListener("popstate", (e) => {
      const path = window.location.pathname;
      const hash = window.location.hash;

      // Versuche über URL-Pfad (ohne Hash)
      if (path && path !== "/") {
        const pathSlug = path
          .split("/")
          .filter((p) => p)
          .pop();
        swiper.slides.forEach((slide, index) => {
          const slideSlug = slide.getAttribute("data-slug");
          if (slideSlug === pathSlug) {
            swiper.slideTo(index);
          }
        });
      } else if (hash) {
        // Fallback: Versuche über Hash
        const slideIdMatch = hash.match(/#slide-(\d+)/);
        if (slideIdMatch) {
          const targetSlideId = slideIdMatch[1];
          swiper.slides.forEach((slide, index) => {
            if (slide.getAttribute("data-slide-id") === targetSlideId) {
              swiper.slideTo(index);
            }
          });
        } else {
          const slug = hash.replace("#", "");
          swiper.slides.forEach((slide, index) => {
            if (slide.getAttribute("data-slug") === slug || slide.id === slug) {
              swiper.slideTo(index);
            }
          });
        }
      } else {
        // Keine URL-Parameter -> Slide 0
        swiper.slideTo(0);
      }
    });

    // Hash-Change Event als Fallback
    window.addEventListener("hashchange", () => {
      const hash = window.location.hash;
      if (hash) {
        const slideIdMatch = hash.match(/#slide-(\d+)/);
        if (slideIdMatch) {
          const targetSlideId = slideIdMatch[1];
          swiper.slides.forEach((slide, index) => {
            if (slide.getAttribute("data-slide-id") === targetSlideId) {
              swiper.slideTo(index);
            }
          });
        } else {
          const slug = hash.replace("#", "");
          swiper.slides.forEach((slide, index) => {
            if (slide.getAttribute("data-slug") === slug || slide.id === slug) {
              swiper.slideTo(index);
            }
          });
        }
      }
    });

    console.log(
      "Fullscreen Swiper initialisiert mit",
      swiper.slides.length,
      "Slides",
    );
  }

  // Funktion zum Aktualisieren der Canonical URL für SEO
  function updateCanonicalURL(url) {
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalLink);
    }
    const baseUrl = window.location.origin;
    const fullUrl = url.startsWith("/") ? baseUrl + url : baseUrl + "/" + url;
    canonicalLink.setAttribute("href", fullUrl);
  }

  // Matomo (Pageviews bei normaler Navigation)

  // Honorar Accordion-Klapper
  const honorarContent = document.querySelector(".honorar-content");
  if (honorarContent) {
    let allGroups = honorarContent.querySelectorAll(":scope > .wp-block-group");
    if (allGroups.length === 0) {
      allGroups = honorarContent.querySelectorAll(".wp-block-group");
    }
    const groups = Array.from(allGroups).filter(
      (g) => !g.querySelector(".wp-block-buttons"),
    );
    groups.forEach((group) => {
      const inner =
        group.querySelector(".wp-block-group__inner-container") || group;
      const heading = inner.querySelector("h2, h3, h4");
      if (!heading) return;

      const siblings = Array.from(inner.children);
      const idx = siblings.indexOf(heading);
      const contentEls = siblings
        .slice(idx + 1)
        .filter((el) => !el.classList.contains("wp-block-buttons"));
      if (contentEls.length === 0) return;

      const details = document.createElement("details");
      details.className = "honorar-accordion-item";

      const summary = document.createElement("summary");
      summary.className = "honorar-accordion-header";
      summary.appendChild(heading);

      const contentWrap = document.createElement("div");
      contentWrap.className = "honorar-accordion-body";
      contentEls.forEach((el) => contentWrap.appendChild(el));

      details.appendChild(summary);
      details.appendChild(contentWrap);
      group.replaceWith(details);
    });
  }

  // Rechtsgebiete Tab-Funktionalität
  const rechtsgebieteTabs = document.querySelectorAll(".rechtsgebiete-tab");
  const rechtsgebieteContents = document.querySelectorAll(
    ".rechtsgebiete-content",
  );

  rechtsgebieteTabs.forEach((tab) => {
    tab.addEventListener("click", (e) => {
      e.stopPropagation();
      const targetTab = tab.getAttribute("data-tab");

      // Alle Tabs deaktivieren
      rechtsgebieteTabs.forEach((t) => t.classList.remove("active"));
      // Aktiven Tab aktivieren
      tab.classList.add("active");

      // Alle Contents ausblenden
      rechtsgebieteContents.forEach((content) => {
        content.classList.remove("active");
      });
      // Ziel-Content anzeigen
      const targetContent = document.querySelector(
        `.rechtsgebiete-content[data-content="${targetTab}"]`,
      );
      if (targetContent) {
        targetContent.classList.add("active");
      }
    });
  });
});
